module.exports = __webpack_public_path__ + "img/einspeisebeteiligung.527b1f84.png";